import { PlotsListPage } from '@/components/plots/plots-list-page'

export function AdminPlots() {
  return <PlotsListPage plotsBasePath="/admin/plots" membersBasePath="/admin/members" canManage />
}
